import { RouteMetadata } from './types';

export const canvasMetadata: RouteMetadata[] = [
    {
        pattern: '/agents/:agentId/canvas/:canvasId',
        section: 'canvas',
        view: 'editor',
        descriptionTemplate: 'User is editing canvas {canvasId}',
        capabilities: [
            'Arrange canvas items and connections',
            'Edit item descriptions and labels',
            'Manage canvas sharing and visibility',
            'Review activity, threads, and viewers',
        ],
        hints: [
            'Canvas editor is used for visual brainstorming across media items',
            'Items can include image, audio, and PDF assets',
            'Connections represent relationships between items',
        ],
    },
    {
        pattern: '/agents/:agentId/canvas',
        section: 'canvas',
        view: 'list',
        descriptionTemplate: 'User is viewing the canvas list',
        capabilities: [
            'Browse canvases by ownership and source filters',
            'Search canvases and item-level matches',
            'Create, rename, and delete canvases',
            'Open a canvas editor',
        ],
        hints: [
            'Canvas list supports ownership, source, and media filters',
            'Search can match both canvas names and item content',
            'Creating a canvas opens the editor immediately',
        ],
    },
];
